import { NOOP } from '~/utils/noops';

type SentryT = typeof Sentry;

export const captureException = globalThis.Sentry?.captureException ?? (NOOP as SentryT['captureException']);
export const setUser = globalThis.Sentry?.setUser ?? (NOOP as SentryT['setUser']);
